import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    DatePicker,
    ProTableOt, DeleteButton, PostButton,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag,
    Select,

} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import ScrappedListForm from "./scrapped_list_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import ScrappedListEdit from './scrapped_list_edit'
import { ScrappedListExcelExport } from './scrapped_list_excel_export'
import dayjs from 'dayjs';
import ScrappedListProgressModal from "./scrapped_list_progress_modal";
import ScrappedListChangeLogModal from "./scrapped_list_change_log_modal";
import { getStatusClassNames } from "antd/lib/_util/statusUtils";

const ScrappedListTable = ({
    rowKey = "list_id",
    keyPrefix = "cataloging.scrapped_list_management",
    showAllColumns = true,
    propsShowColumns,
    propslist_id,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [statusByListId, setStatusByListId] = useState({})
    const statusByListIdRef = useRef({})
    const handleStatusChange = useCallback((listId, statusName) => {
        if (statusByListIdRef.current[listId] === statusName) return
        const next = {
            ...statusByListIdRef.current,
            [listId]: statusName
        }
        statusByListIdRef.current = next
        setStatusByListId(next)
    }, [])
    const [tableSearchParams, setTableSearchParams] = useState({
        list_id: propslist_id || null,
        start_planneddate: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end_planneddate: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    });
    const columns = useMemo(() => [
        {
            title: "清單編號",
            key: "list_number",
            dataIndex: "list_number",
            sorter: false,
        },
        {
            title: "清單名稱",
            key: "list_task_data",
            dataIndex: "list_task_data",
            sorter: false,
            render: (text, record, index) => {
                let list_task_data = text || []
                let list_task_data_first = list_task_data?.find((e) => true)
                return <Row justify="center">
                    <Col>
                        {list_task_data_first?.task_name}
                    </Col>
                </Row>
            }
        },
        {
            title: t("disposal_status"),
            key: "description_opac",
            dataIndex: "description_opac",
            sorter: false,

        },
        {
            title: t("disposal_reason"),
            key: "reason",
            dataIndex: "reason",
            sorter: false,

        },
        {
            title: t("disposal_collection_quantity"),
            key: "disposal_collection_quantity",
            dataIndex: "items_list_items_data",
            sorter: false,

            render: (text, record, index) => {
                let disposal_collection_quantity = text.length
                return <Row justify="center">
                    <Col>
                        {disposal_collection_quantity}
                    </Col>
                </Row>
            }
        },
        {
            title: "更新狀態",
            key: "update_status",
            dataIndex: "list_id",
            sorter: false,

            render: (text, record, index) => {
                let list_id = text
                return <Row justify="center">
                    <Col>
                        <ListStatus
                            list_id={list_id}
                            statusName={statusByListIdRef.current[list_id]}
                            onStatusChange={handleStatusChange}
                        />
                    </Col>
                </Row>
            }
        },
        {
            title: t("creator"),
            key: "create_user_name",
            dataIndex: "create_user_name",
            sorter: false,

        },
        {
            title: t("creation_time"),
            key: "create_time",
            dataIndex: "create_time",
            sorter: false,
            render: (text, record, index) => {
                return <Typography.P>
                    {dayjs(text).format('YYYY-MM-DD HH:mm:ss')}
                </Typography.P>
            }
        },
    ], [handleStatusChange, t]);
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();

    const navigate = useNavigate()


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const SerialController = useCRUDController({
        apiRoute: "/koha/serial",
    })
    const ScrappedListController = useCRUDController({
        apiRoute: "/library/scrapped_list",
        onFinish,
        onBefore
    })
    useEffect(() => {
        checkAll();
        SerialController.getData({
        })
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [
                        <Row gutter={[8, 8]}>
                            <Col>
                                <ScrappedListProgressModal />
                            </Col>
                            <Col>
                                <ScrappedListChangeLogModal />
                            </Col>
                            <Col>
                                {permission_level === 1 ?
                                <PostButton
                                    ischildren={false}
                                    onClick={() => {
                                        navigate(`../scrapped_list_management?mode=new`)
                                    }}
                                />
                                : <></>}
                            </Col>

                        </Row>
                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    let newTableSearchParams = { ...tableSearchParams }

                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        // list_id: tableSearchParams?.list_id,
                        ...newTableSearchParams,

                        // status: "1"
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return ScrappedListController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }

                            })
                            ScrappedListController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                    claimdate: !!formValue?.claimdate ? formValue?.claimdate : null
                                }
                            })
                            ScrappedListController.patchData(patchData)
                        },
                        deleteData: ScrappedListController.deleteData
                    }
                }}
                PropsPatchForm={<ScrappedListForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={false}
                propsDelete={false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
                extraActionRender={(record) => {
                    return (
                    permission_level === 1 ? 
                    <ScrappedListActions
                        record={record}
                        statusName={statusByListId[record?.list_id]}
                        onDelete={() => ScrappedListController.deleteData([record])}
                    />
                    : <></>)
                }}
            />
        </Col>
    </Row>)

}
const ScrappedList = ({
    keyPrefix = "cataloging.scrapped_list_management",
    permission_level = null, 
}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const list_id = searchParams.get('list_id');
    const mode = searchParams.get('mode');
    return (
        <Row gutter={[10, 20]} >
            {
                ((mode === "view" && !list_id) || !mode) && <Col span={24}>
                    <ScrappedListTable
                        keyPrefix={keyPrefix}
                        permission_level={permission_level}
                    />
                </Col>
            }
            {
                (mode === "new" || mode === "edit" || (mode === "view" && list_id)) && <Col span={24}>
                    <ScrappedListEdit keyPrefix={keyPrefix} />
                </Col>
            }


        </Row>
    );
};
const ScrappedListActions = ({ record, statusName, onDelete }) => {
    const navigate = useNavigate()
    const [showCorrectionActions, setShowCorrectionActions] = useState(false)

    const completed = statusName === "更新成功" || statusName === "已完成"
    const inProgress = statusName === "進行中"
    const statusError = statusName === "狀態讀取失敗"
    const knownStatuses = ["進行中", "更新失敗"]
    const unknownStatus = !!statusName && !completed && !knownStatuses.includes(statusName) && !statusError
    const statusUnavailable = !statusName || statusError || unknownStatus

    const editButton = <Button
        onClick={() => navigate(`../scrapped_list_management?mode=edit&list_id=${record?.list_id}`)}
        style={{
            backgroundColor: '#BBDEFB',
            color: '#1976D2'
        }}
    >
        編輯
    </Button>

    return <Row gutter={[8, 8]}>
        {statusUnavailable ? <Col>
            <Button disabled>
                {statusError ? "狀態讀取失敗" : unknownStatus ? "未知狀態" : "狀態讀取中"}
            </Button>
        </Col> : inProgress ? <Col>
            <Button onClick={() => message.info(`此清單正在進行更新，請勿重複操作`)}>
                更正申請
            </Button>
        </Col> : completed && !showCorrectionActions ? <Col>
            <Button onClick={() => setShowCorrectionActions(true)}>
                更正申請
            </Button>
        </Col> : <>
            <Col>{editButton}</Col>
            <Col><DeleteButton onConfirm={onDelete} /></Col>
        </>}
        <Col>
            <ScrappedListExcelExport data={record} mode={"view"} />
        </Col>
    </Row>
}
const ListStatus = ({
    list_id,
    statusName,
    onStatusChange = () => { }
}) => {
    const onStatusChangeRef = useRef(onStatusChange)
    const ScrappedController = useCRUDController({
        apiRoute: "/library/scrapped_list/progress",
    })
    const scrappedControllerRef = useRef(ScrappedController)
    const statusTag = (name) => {
        let color = "default"
        if (name === "進行中") {
            color = "gold-inverse"
        }
        else if (name === "更新成功") {
            color = "success"
        }
        else if (name === "更新失敗") {
            color = "error"
        }
        return <Tag color={color}>
            {name || "讀取中"}
        </Tag>
    }

    useEffect(() => {
        onStatusChangeRef.current = onStatusChange
    }, [onStatusChange])

    useEffect(() => {
        let cancelled = false
        const controller = scrappedControllerRef.current

        if (!list_id || statusName) return () => { cancelled = true }

        controller.getData({ list_id })
            .then((res) => {
                if (cancelled) return

                let data = res.data || []
                let latestData = data.find(e => true)
                let name = latestData?.task_explaination || "已完成"
                onStatusChangeRef.current(list_id, name)
            })
            .catch(() => {
                if (cancelled) return

                onStatusChangeRef.current(list_id, "狀態讀取失敗")
            })

        return () => {
            cancelled = true
            controller.cancelPending()
        }
    }, [list_id, statusName])

    return (
        <Row>
            <Col>
                {statusTag(statusName)}
            </Col>
        </Row>
    )
}
export { ScrappedListTable }
export default ScrappedList;
